import noImageCompany from '../../../../../assets/images/emptyCompany.jpg';
import CardCollection from '../../../../layouts/Card/cardContent/CardCollection';

export const listSettings = {
    grid : {
        components : CardCollection,
        columns : {
            xs : 2,
            sm : 3,
            laptop : 4,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : ['6'],
}

